import { isNil } from "lodash-es";
import IVendorModel from "../models/IVendorModel";
import RestEndpointsEnum from "../models/RestEndpointsEnum";
import { buildRestUrlWithQuery, buildAuthHeadersForFetch } from "./RestService";
import IUserUI from "../models/IUserUI";
import ISupplierModel from "../models/ISupplierModel";
import IOnGetVendorsDTO from "../models/DTO/IOnGetVendorsDTO";

const getLocalVendorData = (): Promise<IVendorModel> => {
    return new Promise((resolve, reject) => {
        try {
            const vendor = localStorage.getItem("vendor");

            if (isNil(vendor)) {
                reject(new Error("Error finding vendor in local storage."));
            } else {
                const parsedVendor = JSON.parse(vendor) as IVendorModel;

                resolve(parsedVendor);
            }
        } catch (err) {
            reject(err);
        }
    });
};

const getLocalVendorDataFn = (): IVendorModel => {
    const vendor = localStorage.getItem("vendor");

    if (isNil(vendor)) {
        console.log("No vendor found in local storage, returning empty vendor model.");
        return {} as IVendorModel;
    } else {
        const parsedVendor = JSON.parse(vendor) as IVendorModel;
        return parsedVendor;
    }
};

const saveVendorData = (data: any) => {
    data.dataAge = Date.now();

    const vendorData = JSON.stringify(data);

    localStorage.setItem("vendor", vendorData);
};

const clearVendorData = () => {
    return new Promise((resolve, reject) => {
        try {
            localStorage.removeItem("vendor");

            resolve(true);
        } catch (err) {
            reject(err);
        }
    });
};

const getVendors = async (name: string, userModel: IUserUI, supplierModel: ISupplierModel): Promise<IVendorModel[]> => {
    const url = buildRestUrlWithQuery({
        endpoint: RestEndpointsEnum.VendorGetVendors,
        query: { name, limit: 25 },
    });

    const headers = buildAuthHeadersForFetch({ userModel, supplierModel });

    const response = await fetch(url, { method: "GET", headers });

    if (!response.ok) {
        throw new Error(`Failed to fetch vendors: ${response.statusText}`);
    }

    const data = (await response.json()) as IOnGetVendorsDTO;
    return data.supplierVendorTokens.map((token) => token.Vendor!);
};

const VendorService = {
    clearVendorData,
    getLocalVendorData,
    getLocalVendorDataFn,
    getVendors,
    saveVendorData,
};

export default VendorService;
